import { cn } from "@/lib/utils";

/** Star-Tales-Stern; funktioniert auf heller und dunkler Fläche. */
export function AppLogo({ className }: { className?: string }) {
  return (
    <img
      src="/logo.svg"
      alt=""
      aria-hidden
      className={cn("size-6 shrink-0", className)}
    />
  );
}
